import moment from "moment";

/*
const BOOLEANS_STRING_TOKENS = [
  "s",
  "S",
  "sim",
  "Sim",
  "y",
  "Y",
  "Yes",
  "n",
  "N",
  "nao",
  "Nao",
  "não",
  "Não",
];
*/
export enum TypeRecords {
  CURRENCY = "currency",
  DATE = "date",
  TIME = "time",
  DATE_TIME = "dateTime",
  TEXT = "text",
  PERCENT1 = "percent1",
  PERCENT2 = "percent2",
  PERCENT3 = "percent3",
  INT = "int",
  DECIMAL1 = "decimal1",
  DECIMAL2 = "decimal2",
  DECIMAL3 = "decimal3",
  CPF_CNPJ = "cpfCnpj",
  CHECK = "check",
}

export type TYPE_ALIGN = "left" | "center" | "right" | "justify";

class Formater {
  static toAlign(type?: TypeRecords, defaultAlign?: TYPE_ALIGN): TYPE_ALIGN {
    switch (type) {
      case TypeRecords.INT:
      case TypeRecords.CURRENCY:
      case TypeRecords.PERCENT1:
      case TypeRecords.PERCENT2:
      case TypeRecords.PERCENT3:
      case TypeRecords.DECIMAL1:
      case TypeRecords.DECIMAL2:
      case TypeRecords.DECIMAL3:
        return defaultAlign || "right";
      case TypeRecords.CHECK:
        return defaultAlign || "center";
      default:
        return defaultAlign || "left";
    }
  }

  static toString(
    value: any,
    type?: TypeRecords,
    withSymbol: boolean = true
  ): any {
    let _date: any;
    switch (type) {
      case TypeRecords.TEXT:
      case undefined:
        return String(value);

      case TypeRecords.CHECK:
        return value === true ||
          ["SIM", "S", "YES", "Y"].includes(String(value).toUpperCase())
          ? "Sim"
          : "-";

      case TypeRecords.INT:
        return parseInt(value);

      case TypeRecords.PERCENT1:
        return `${parseFloat(value).toFixed(1).replace(".", ",")}${withSymbol ? " %" : ""}`;
      case TypeRecords.PERCENT2:
        return `${parseFloat(value).toFixed(2).replace(".", ",")}${withSymbol ? " %" : ""}`;
      case TypeRecords.PERCENT3:
        return `${parseFloat(value).toFixed(3).replace(".", ",")}${withSymbol ? " %" : ""}`;

      case TypeRecords.DECIMAL1:
        return `${parseFloat(value).toFixed(1).replace(".", ",")}`;

      case TypeRecords.DECIMAL2:
        return `${parseFloat(value).toFixed(2).replace(".", ",")}`;

      case TypeRecords.DECIMAL3:
        return `${parseFloat(value).toFixed(3).replace(".", ",")}`;

      case TypeRecords.DATE_TIME:
        if (value === undefined || value === null) {
          return "";
        }

        if (typeof value === "string") {
          _date = Formater.toDate(value);
        } else if (value instanceof Date) {
          _date = value;
        }
        return _date ? _date.toLocaleString() : new Date().toLocaleString();
      case TypeRecords.TIME:
        if (value === undefined || value === null) {
          return "";
        }

        _date = Formater.toDate(value);
        return _date.toLocaleTimeString();
      case TypeRecords.DATE:
        if (value === undefined || value === null) {
          return "";
        }

        _date = Formater.toDate(value);
        return _date.toLocaleDateString();

      case TypeRecords.CURRENCY:
        return parseFloat(value || 0).toLocaleString("pt-br", { style: "currency", currency: "BRL" });

      case TypeRecords.CPF_CNPJ:
        if (String(value).length === 11) {
          return (value.substring(0, 3) + "." + value.substring(3, 6) + "." + value.substring(6, 9) + "-" + value.substring(9, 11));
        }

        if (String(value).length === 14) {
          return (value.substring(0, 2) + "." + value.substring(2, 5) + "." + value.substring(5, 8) + "/" + value.substring(8, 12) + "-" + value.substring(12, 14));
        }

        return value;
      default:
        return value;
    }
  }

  static toDate(value: string): Date {
    //year: number, month: number, date?: number, hours?: number, minutes?: number, seconds?: number, ms?: number
    if (String(value).length > 11) {
      return new Date(
        parseInt(String(value).substring(0, 4)),
        parseInt(String(value).substring(5, 7)) - 1,
        parseInt(String(value).substring(8, 10)),
        parseInt(String(value).substring(11, 13)),
        parseInt(String(value).substring(14, 16)),
        parseInt(String(value).substring(17, 19))
      );
    }

    return new Date(
      parseInt(String(value).substring(0, 4)),
      parseInt(String(value).substring(5, 7)) - 1,
      parseInt(String(value).substring(8, 10))
    );
  }

  static localToDate(value: string): Date {
    //year: number, month: number, date?: number, hours?: number, minutes?: number, seconds?: number, ms?: number
    return new Date(
      parseInt(String(value).substring(0, 4)),
      parseInt(String(value).substring(5, 7)) - 1,
      parseInt(String(value).substring(8, 10)),
      parseInt(String(value).substring(11, 13)),
      parseInt(String(value).substring(14, 16)),
      parseInt(String(value).substring(17, 19))
    );
  }

  static parseDateDB(value: string, withoutTime: boolean = false): string {
    const _value = value
    if (_value.replace(/^\d{2}\/\d{2}\/\d{4}$/, "") !== ""
      && _value.replace(/^\d{2}\/\d{2}\/\d{4}\s\d{2}:\d{2}:\d{2}$/, "") !== ""
      && _value.replace(/^\d{2}\/\d{2}\/\d{4}\s\d{2}:\d{2}$/, "") !== ""
    ) {
      return "invalid date"
    }

    if (_value.replace(/^\d{2}\/\d{2}\/\d{4}$/, "") === "" && withoutTime) {
      return moment(_value, "DD/MM/YYYY").format("YYYY-MM-DD")
    }

    if (_value.replace(/^\d{2}\/\d{2}\/\d{4}$/, "") === "") {
      return moment(_value, "DD/MM/YYYY").format("YYYY-MM-DD 00:00:00")
    }

    if (_value.replace(/^\d{2}\/\d{2}\/\d{4}\s\d{2}:\d{2}:\d{2}$/, "") === "") {
      return moment(_value, "DD/MM/YYYY").format("YYYY-MM-DD HH:mm:ss")
    }

    if (_value.replace(/^\d{2}\/\d{2}\/\d{4}\s\d{2}:\d{2}$/, "") === "") {
      return moment(_value, "DD/MM/YYYY").format("YYYY-MM-DD HH:mm")
    }

    return "invalid date"
  }
}

export { Formater };
